
function SdDatePickerController($scope, TranslationService) {
    var ctrl = this;
    ctrl.placeholder = '';
    //ctrl.dateFocus = 'start';
    ctrl.isStartFocus = true;
    ctrl.hasEndDate = false;

    ctrl.translation = TranslationService.getActiveTranslation();
    ctrl.today = new Date();
    ctrl.todayDay = ctrl.today.getDate();

    ctrl.$onInit = function () {
        //console.log('$onInit');

        ctrl.selectCount = 0;
        
        ctrl.weeks = [
            { name: ctrl.translation.Sun, index: 0 },
            { name: ctrl.translation.Mon, index: 1 },
            { name: ctrl.translation.Tue, index: 2 },
            { name: ctrl.translation.Wed, index: 3 },
            { name: ctrl.translation.Thu, index: 4 },
            { name: ctrl.translation.Fri, index: 5 },
            { name: ctrl.translation.Sat, index: 6 },
        ];
        //ctrl.initMonth(ctrl.today);
        if (ctrl.startDate) {
            //console.log('existe data');
            ctrl.initMonth(ctrl.startDate);
        }
    };

    ctrl.$onChanges = function (changes) {
        //console.log('sd-date-picker.$onChanges', changes, ctrl.startDate);
        if (ctrl.startDate) {
            ctrl.initMonth(ctrl.startDate);
        }
        else {
            ctrl.initMonth(ctrl.today);
        }
    };

    $scope.$watch('$ctrl.startDate', function (newValue, oldValue) {
        // Handle property changes here        
        //console.log('startDate changed:', newValue, ctrl.isOpen);
        if (newValue && !ctrl.isOpen) {            
            ctrl.initMonth(newValue);
        }
    });

    ctrl.initMonth = function (today) {
        //console.log('initMonth ' + today);
        ctrl.curMonth = today;
        var curDay = today.getDate();
        var beginMonth = ctrl.monthFirstDay(today);
        var firstDate = ctrl.getSunday(beginMonth);
        var curDate = firstDate;
        ctrl.rows = [];
        for (var week = 0; week < 5; week++) {
            var days = [];
            for (var d = 1; d <= 7; d++) {
                curDay = curDate.getDate();
                var day = {
                    Day: curDay,
                    Shifts: [],
                    Exceptions: [],
                    DayDate: curDate,
                    DayID: curDate.getDay() + 1,
                };
                days.push(day);
                curDate = ctrl.nextDay(curDate);
            }
            ctrl.rows.push({
                week: week,
                days: days
            });
        }
    };

    ctrl.monthFirstDay = function (aDate) {
        var beginMonth = new Date(aDate.getUTCFullYear(), aDate.getUTCMonth(), 1);
        return beginMonth;
    };

    ctrl.addMonth = function (aDate, inc) {
        if (!aDate) {
            return null;
        }
        return new Date(aDate.getUTCFullYear(), aDate.getUTCMonth() + inc, aDate.getUTCDate());
    };

    ctrl.nextDay = function (expDate) {
        if (!expDate) {
            return null;
        }
        return new Date(expDate.getUTCFullYear(), expDate.getUTCMonth(), expDate.getUTCDate() + 1);
    };

    ctrl.sameMonth = function (d1, d2) {
        if (!d1) {
            return false;
        }
        if (!d2) {
            return false;
        }
        return d1.getUTCFullYear() === d2.getUTCFullYear() &&
            d1.getUTCMonth() === d2.getUTCMonth();
    };

    ctrl.sameDay = function (d1, d2) {
        if (!d1) {
            return false;
        }
        if (!d2) {
            return false;
        }
        return d1.getUTCFullYear() === d2.getUTCFullYear() &&
            d1.getUTCMonth() === d2.getUTCMonth() &&
            d1.getUTCDate() === d2.getUTCDate();
    };

    ctrl.getSunday = function (date) {
        var today = date.getDate();
        var dayOfTheWeek = date.getDay();
        var newDate = date.setDate(today - (dayOfTheWeek || 7));
        return new Date(newDate);
    }; 

    ctrl.incMonth = function (inc) {
        var nextMonth = ctrl.addMonth(ctrl.curMonth, inc);
        ctrl.initMonth(nextMonth);
    };


    ctrl.selectDay = function (day) {
        if (ctrl.isStartFocus) {
            ctrl.startDate = day.DayDate;
        }
        else {
            ctrl.endDate = day.DayDate;
        }
    };

    ctrl.previousMonth = function () {
        ctrl.incMonth(-1);
    };

    ctrl.nextMonth = function () {
        ctrl.incMonth(1);
    };


    ctrl.inputChanged = function () {
        ctrl.onChanged();
    };

    ctrl.clear = function () {
        ctrl.startDate = null;
        ctrl.onChanged();
    };

    /*
    ctrl.selectDateFocus = function (dateFocus) {
        ctrl.dateFocus = dateFocus;
        if (dateFocus == 'start') {
            ctrl.focusedDate = ctrl.startDate;
            ctrl.isStartFocus = true;
        }
        else {
            ctrl.focusedDate = ctrl.endDate;
            ctrl.isStartFocus = false;
        }
    };
    */

    ctrl.toggleHasEndDate = function (ev) {
        //console.log('toggle has date', ev);
        if (ctrl.hasEndDate) {
            if (!ctrl.endDate) {
                ctrl.endDate = ctrl.startDate;
                ctrl.isStartFocus = false;
            }
        }
        else {
            ctrl.endDate = null;
            ctrl.isStartFocus = true;
        }
    };

    ctrl.getFocusedDate = function () {        
        if (ctrl.isStartFocus) {
            return ctrl.startDate;
        }
        else {
            return ctrl.endDate;
        }
    };

    ctrl.isDayRange = function (dayDate) {
        if (ctrl.hasEndDate && ctrl.endDate) {
            return dayDate > ctrl.startDate && dayDate < ctrl.endDate;
        }
        else {
            return false;
        }
    };

    ctrl.clear = function () {
        ctrl.startDate = null;
        ctrl.endDate = null;
        ctrl.hasEndDate = false;
    };
}

SdDatePickerController.$inject = ['$scope','TranslationService'];

seedWebApp.component('sdDatePicker', {
    controller: SdDatePickerController,
    bindings: {
        name: '@',
        label: '<',             // Label do input
        isOpen: '<',
        startDate: '=',
        endDate: '=',   
        hasEndDate: '=',
        canClear: '<',
        disabled: '<',          // Define se campo está desabilitado para edição
        placeholder: '<',
        onChanged: '&'
    },
    templateUrl: '/SPA/components/sd-date-picker.html' + seedWebApp.buildVersion
});
